var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.table_header,"items":_vm.$store.getters.trans_hist,"items-per-page":50}})}
var staticRenderFns = []

export { render, staticRenderFns }